import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading)
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground">
        <div className="animate-pulse">Loading…</div>
      </div>
    );

  if (!user)
    return <Navigate to="/start" state={{ from: location }} replace />;

  if (adminOnly && !["owner_admin", "admin"].includes(user.role))
    return <Navigate to="/" replace />;

  return children;
}
